'use client';
import { AgriNews } from '@ninjacart/nc-nk-app';
import { Article } from "@ninjacart/nc-nk-core";
export function AgriNewsList({ articles, initialMaxId }: { articles: Article[], initialMaxId: string }) {
  return <AgriNews articles={articles} initialMaxId={initialMaxId} />;
}
